import * as Preact from "preact"
import Navigation from "@frog/source/models/Navigation.js"

import "@frog/source/views/app/screens/ErrorScreen.view.less"

const expletive = "Damn It"

// TODO: Expand or branch this view for more kinds
// of errors, beyond just the url user error. Let
// it support some good debugging information for
// our players to troubleshoot and report.

export default class SplashScreen {
    render() {
        return (
            <div class="ErrorScreen" onClick={this.onClick}>
                <div class="Expletive">
                    {expletive}
                </div>
                <div class="ErrorMessage">
                    {Navigation.state.message}
                </div>
                <div class="Prompt">
                    Click anywhere to go back.
                </div>
            </div>
        )
    }
    onClick(event) {
        Navigation.goBack()
    }
}
